const fontSizes = {
  xs: 12,
  sm: 13,
  md: 15,
  lg: 16,
  xl: 17,
  xxl: 18,
  xxxl: 21,
  xxxxl: 32,
};

const fontWeights = {
  regular: 400,
  medium: 500,
  bold: 700,
};

const light = {
  colors: {
    primary: '#674AF6',
    secondary: '#C9C1F4',
    ui_1: '#FCFCFD',
    ui_2: '#F2F2F3',
    ui_3: '#E9E9EB',
    ui_4: '#DCDCDD',
    ui_on_1: '#0A0A0A',
    ui_on_2: '#383839',
    ui_on_3: '#808080',
    ui_on_4: '#949494',
    danger: '#FF5555',
    focus: '#8FE3EF',
    white: '#FFFFFF',
    black: '#000000',
    defaultHover: '#0000a00a',
  },
  fontSizes,
  fontWeights,
};

const dark = {
  colors: {},
  fontSizes,
  fontWeights,
};

export const THEME_TYPES = {
  LIGHT: 'light',
  DARK: 'dark',
};

const themes = {
  light,
  dark,
};

export default themes;
